import {usePortalClient} from '../context/PortalClientContext';

// El cliente ACTIVO del portal. Delegado al PortalClientContext (multi-cliente), que ya
// resuelve la cascada preview → provider → fallback legacy (logged_user_client_id).
export const usePortalClientId = () => {
    const {activeClientId} = usePortalClient();
    return activeClientId ? String(activeClientId) : null;
};
